import {useRef, useState} from 'react';
import ImageEditModal from './ImageEditModal';
import '../App.css';

// 기존 서비스 데이터
const services = [
    {
        title: 'Brand Activation',
        description: '단순한 인지를 넘어 소비자의 행동을 이끌어냅니다. 브랜드의 메시지가 타겟의 일상에 깊숙이 침투하여 강력한 팬덤을 형성하는 통합 홍보 솔루션을 제공합니다.',
        icon: (
            <svg className="service-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.2">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
        ),
    },
    {
        title: 'Media PR Strategy',
        description: '최적화된 미디어 믹스를 통해 브랜드 노출을 극대화합니다. 정교한 언론 홍보와 디지털 바이럴을 결합하여 시장 내 브랜드의 권위와 신뢰도를 단기간에 구축합니다.',
        icon: (
            <svg className="service-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.2">
                <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
                <line x1="8" y1="21" x2="16" y2="21"/>
                <line x1="12" y1="17" x2="12" y2="21"/>
            </svg>
        ),
    },
    {
        title: 'Digital Campaign',
        description: '데이터 분석을 기반으로 고도화된 퍼포먼스 마케팅을 전개합니다. 실시간 성과 측정을 통해 광고 효율을 최적화하고 가시적인 매출 성장을 이끌어냅니다.',
        icon: (
            <svg className="service-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" strokeWidth="1.2">
                <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
                <line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
        ),
    },
];

// 프로세스 데이터
const processSteps = [
    {
        title: '브랜드 진단',
        desc: '검색 동선 및 경쟁사 정밀 분석을 통해 현재 브랜드의 위치와 문제점을 파악합니다.',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.3-4.3"/>
        </svg>
    },
    {
        title: '콘텐츠 전략 설계',
        desc: '목표 키워드 설정 및 최적화된 콘텐츠 구조를 설계하여 도달율을 극대화합니다.',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
        </svg>
    },
    {
        title: '운영 및 제작',
        desc: '채널별 맞춤 콘텐츠를 직접 제작하고 배포하여 브랜드 신뢰도를 구축합니다.',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 20h9"/>
            <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/>
        </svg>
    },
    {
        title: '고도화 및 최적화',
        desc: '성과 모니터링을 통한 CTR 개선 및 콘텐츠 리사이클링으로 효율을 지속시킵니다.',
        icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round">
            <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
            <polyline points="16 7 22 7 22 13"/>
        </svg>
    }
];

const ASSET_LABELS = {
    HERO_MAIN_IMAGE: 'Hero 메인 이미지',
    ABOUT_IMAGE: 'About 이미지',
    HEADER_LOGO: 'Header 로고',
    FOOTER_LOGO: 'Footer 로고',
};

function SitePage({assets = {}, isAdmin = false, onUpload}) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [editTarget, setEditTarget] = useState(null);

    const fileRefs = {
        HERO_MAIN_IMAGE: useRef(null),
        ABOUT_IMAGE: useRef(null),
        HEADER_LOGO: useRef(null),
        FOOTER_LOGO: useRef(null),
    };

    const handleFileSelect = (assetKey) => fileRefs[assetKey]?.current?.click();
    const handleFileChange = (assetKey, e) => {
        const file = e.target.files?.[0];
        if (file) setEditTarget({assetKey, file});
        e.target.value = '';
    };

    const handleEditConfirm = (croppedFile) => {
        if (onUpload && editTarget) onUpload(editTarget.assetKey, croppedFile);
        setEditTarget(null);
    };

    const headerLogoUrl = assets.HEADER_LOGO?.resolvedUrl ?? 'https://placehold.jp/30/dddddd/999999/1200x800.png?text=Preparing+Image...';
    const aboutImageUrl = assets.ABOUT_IMAGE?.resolvedUrl ?? 'https://placehold.jp/30/dddddd/999999/1200x800.png?text=Preparing+Image...';

    return (
        <div className={`site-wrapper ${mobileOpen ? 'nav-active' : ''}`}>
            {isAdmin && (
                <div className="admin-hidden-inputs">
                    {Object.keys(fileRefs).map((key) => (
                        <input key={key} type="file" accept="image/*" ref={fileRefs[key]}
                               onChange={(e) => handleFileChange(key, e)}/>
                    ))}
                </div>
            )}

            {editTarget && (
                <ImageEditModal
                    file={editTarget.file}
                    assetLabel={ASSET_LABELS[editTarget.assetKey] ?? editTarget.assetKey}
                    onConfirm={handleEditConfirm}
                    onCancel={() => setEditTarget(null)}
                />
            )}

            {/* HEADER */}
            <header className="main-header">
                <div className="header-container">
                    <div className="logo-wrap">
                        <div className={isAdmin ? 'img-edit-wrap logo-img-wrap' : 'logo-img-wrap'}>
                            <img src={headerLogoUrl} alt="Logo" className="logo-image"/>
                            {isAdmin && <button className="img-edit-btn"
                                                onClick={() => handleFileSelect('HEADER_LOGO')}>변경</button>}
                        </div>
                        <span className="logo-text">REFRESH</span>
                    </div>
                    <nav className="desktop-nav">
                        <a href="#services" className="nav-link">Expertise</a>
                        <a href="#process" className="nav-link">Process</a>
                        <a href="#about" className="nav-link">Agency</a>
                        <a href="#contact" className="nav-link">Inquiry</a>
                    </nav>
                    <button className="menu-toggle" onClick={() => setMobileOpen(!mobileOpen)}>
                        <div className={`burger ${mobileOpen ? 'active' : ''}`}></div>
                    </button>
                </div>
            </header>



            {/* HERO SECTION */}
            <section className="hero-section">
                <div className="hero-content">
                    <div className="hero-badge">ADVERTISING & PR AGENCY</div>
                    <h1 className="hero-title">
                        We Create  <br />
                        <span className="accent-text">Impactful Brands</span>
                    </h1>
                    <p className="hero-desc">
                        우리는 브랜드가 시장에 던지는 메시지의 무게를 이해합니다.<br />
                        단순한 노출을 넘어 사람들의 기억 속에 각인되는 강력한 홍보 전략을 설계합니다.
                    </p>
                    <div className="hero-actions">
                        <a href="#services" className="btn-primary">OUR EXPERTISE</a>
                        <div className="scroll-indicator">
                            <span className="mouse"></span>
                        </div>
                    </div>
                </div>
            </section>

            {/*  SERVICES SECTION */}
            <section id="services" className="services-section">
                <div className="section-container">
                    <div className="services-top">
                        <div className="title-area">
                            <span className="sub-title">/ OUR EXPERTISE</span>
                            <h2 className="section-title">Strategic Solution</h2>
                        </div>
                        <p className="top-desc">우리는 제작에 머물지 않고<br/>브랜드의 확산을 책임집니다.</p>
                    </div>
                    <div className="services-grid">
                        {services.map((svc, idx) => (
                            <div className="service-card" key={idx}>
                                <div className="card-top">
                                    <span className="card-num">0{idx + 1}</span>
                                    {svc.icon}
                                </div>
                                <h4 className="card-title">{svc.title}</h4>
                                <p className="card-desc">{svc.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* PROCESS SECTION - 레이아웃 유지, 디자인 감성 업그레이드 */}
            <section id="process" className="process-section">
                <div className="section-container">
                    <div className="process-header">
                        <span className="sub-title">/ WORK PROCESS</span>
                        <h2 className="section-title process-title">How We Work</h2>
                    </div>
                    {/* 기존 그리드 레이아웃 100% 유지 */}
                    <div className="process-grid">
                        {processSteps.map((step, i) => (
                            <div key={i} className="process-card">
                                <div className="process-icon-wrap">
                                    {/* 아이콘 선 굵기를 Expertise 섹션과 통일 (1.2px) */}
                                    {require('react').cloneElement(step.icon, {
                                        width: "32",
                                        height: "32",
                                        strokeWidth: "1.2",
                                        stroke: "currentColor"
                                    })}
                                </div>
                                <h4>{step.title}</h4>
                                <p>{step.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ABOUT SECTION -  */}
            <section id="about" className="about-section">
                <div className="section-container">
                    <div className="about-grid">
                        <div className="about-image-side">
                            <div className={isAdmin ? 'img-edit-wrap' : ''}>
                                <img src={aboutImageUrl} alt="About" className="reveal-img"/>
                                {isAdmin &&
                                    <button className="img-edit-btn" onClick={() => handleFileSelect('ABOUT_IMAGE')}>이미지
                                        변경</button>}
                            </div>
                        </div>
                        <div className="about-text-side">
                            <span className="sub-title">/ ADVERTISING & PR</span>
                            <h2 className="section-title">We Drive <br/>Real Results</h2>
                            <p className="description">
                                <span style={{
                                    display: 'block',
                                    marginBottom: '16px',
                                    fontSize: '1rem',
                                    fontWeight: '500',
                                    color: 'var(--navy)'
                                }}>
                                    REFRESH는 <strong>성과 모니터링과 최적화</strong>를 통해 브랜드의 가치를 지속적으로 증명하는 파트너입니다.
                                </span>
                                <span style={{
                                    display: 'block',
                                    color: '#000000',
                                    fontFamily: 'Pretendard, sans-serif',
                                    fontWeight: '200',
                                    letterSpacing: '-0.3px'
                                }}>
                                    단순히 눈에 띄는 디자인을 넘어, 타겟의 심리를 파고드는 날카로운 홍보 전략을 실행합니다. <br/><br/>
                                    콘텐츠 리사이클링과 성과 기반의 고도화 과정을 통해 귀사의 비즈니스가 시장에서 독보적인 위치를 점할 수 있도록 지원합니다.
                                </span>
                            </p>
                            <div className="about-since-tag">PR PARTNER SINCE 2021</div>
                        </div>
                    </div>
                </div>
            </section>

            {/*/!* [추가] STATS SECTION - 아이콘이 포함된 트렌디한 버전 *!/*/}
            {/*<section className="stats-section">*/}
            {/*    <div className="section-container">*/}
            {/*        <div className="stats-grid">*/}
            {/*            {[*/}
            {/*                {*/}
            {/*                    val: '82%+',*/}
            {/*                    label: 'RETENTION RATE',*/}
            {/*                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/><path d="m9 12 2 2 4-4"/></svg>*/}
            {/*                },*/}
            {/*                {*/}
            {/*                    val: '1,500+',*/}
            {/*                    label: 'PROJECTS',*/}
            {/*                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/></svg>*/}
            {/*                },*/}
            {/*                {*/}
            {/*                    val: '300+',*/}
            {/*                    label: 'MONTHLY CONTENTS',*/}
            {/*                    icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><line x1="10" y1="9" x2="8" y2="9"/></svg>*/}
            {/*                }*/}
            {/*            ].map((stat, i) => (*/}
            {/*                <div key={i} className="stat-item">*/}
            {/*                    /!* 아이콘 배치 *!/*/}
            {/*                    <div className="stat-icon-area">*/}
            {/*                        {stat.icon}*/}
            {/*                    </div>*/}
            {/*                    <div className="stat-value">{stat.val}</div>*/}
            {/*                    <div className="stat-label">{stat.label}</div>*/}
            {/*                </div>*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}


            {/* CONTACT SECTION - */}
            <section id="contact" className="contact-section">
                <div className="contact-card">
                    <div className="contact-content">
                        <h2 className="contact-title">Need a <br/>Strategic Partner?</h2>
                        <p className="contact-desc">귀하의 브랜드가 더 넓은 세상으로 나아갈 준비가 되었다면, <br/>리프레시의 통합 홍보 솔루션을 제안받아 보세요.</p>
                    </div>
                </div>
            </section>


            {/* FOOTER */}
            <footer className="main-footer">
                <div className="footer-container">
                    <div className="footer-top">
                        <div className="footer-brand">
                            <span className="footer-logo">REFRESH</span>
                            <p className="footer-tagline">Advertising Agency</p>
                        </div>
                        <div className="footer-links">
                            <div className="link-group">
                                <h5>Core</h5>
                                <a href="#services">Our Strategy</a>
                            </div>
                            <div className="link-group">
                                <h5>Location</h5>
                                <p>Seoul, Korea</p>
                            </div>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p className="copyright">© 2026 REFRESH. All Rights Reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default SitePage;
